/* ============================================================
   Question Everything — qe-core.js
   Ported from dev-site/script.js, with the localStorage demo cart REPLACED by
   real Shopify cart wiring (Section Rendering API → Horizon checkout).
   Multi-root + Shopify.designMode safe.
   ============================================================ */
(function () {
  'use strict';

  var DESIGN_MODE = !!(window.Shopify && window.Shopify.designMode);
  var REDUCED = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var REVEAL_ALL = DESIGN_MODE || REDUCED || navigator.webdriver;

  /* ---------- sticky nav shadow ---------- */
  var shells = document.querySelectorAll('[data-qe-shell]');
  function onShellScroll() {
    var y = window.scrollY || window.pageYOffset;
    shells.forEach(function (s) { s.classList.toggle('is-scrolled', y > 8); });
  }
  if (shells.length) { onShellScroll(); window.addEventListener('scroll', onShellScroll, { passive: true }); }

  /* ---------- reveal on scroll (progressive-enhancement: visible by default in editor) ---------- */
  function revealAll() {
    document.querySelectorAll('.reveal:not(.is-in)').forEach(function (el) { el.classList.add('is-in'); });
  }
  // stagger: tag children of [data-stagger]
  document.querySelectorAll('[data-stagger]').forEach(function (group) {
    Array.prototype.forEach.call(group.children, function (child, i) {
      child.classList.add('reveal');
      if (!child.style.getPropertyValue('--i')) child.style.setProperty('--i', i);
    });
  });
  if (REVEAL_ALL || !('IntersectionObserver' in window)) {
    revealAll();
  } else {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    document.querySelectorAll('.reveal').forEach(function (el) { io.observe(el); });
    setTimeout(revealAll, 3000); // failsafe — nothing ever stuck invisible
  }

  // Shopify editor: sections re-render on edit (e.g. new hero image) and lose the observer;
  // re-reveal so overlay text (kicker/headline/CTA) never stays hidden behind the image.
  document.addEventListener('shopify:section:load', function () { setTimeout(revealAll, 20); });
  document.addEventListener('shopify:section:select', function () { revealAll(); });

  /* ---------- marquee: seamless infinite loop ----------
     The keyframe translates -50%, so one "half" of the track must be >= the
     viewport width or a gap shows (looks like it stops). Fill the set until it
     spans the viewport, THEN duplicate once and normalize speed to width. */
  document.querySelectorAll('.top-banner__track').forEach(function (track) {
    if (track.getAttribute('data-qe-cloned')) return;
    track.setAttribute('data-qe-cloned', '1');
    var originals = Array.prototype.slice.call(track.children);
    if (!originals.length) return;
    var appendClones = function () {
      originals.forEach(function (n) { var c = n.cloneNode(true); c.setAttribute('aria-hidden', 'true'); track.appendChild(c); });
    };
    // 1) fill until one set spans at least the viewport (+ a buffer)
    var guard = 0;
    while (track.scrollWidth < window.innerWidth + 200 && guard < 40) { appendClones(); guard++; }
    // 2) the filled set is one "half"; duplicate the whole thing once so -50% loops with no gap
    var halfWidth = track.scrollWidth;
    Array.prototype.slice.call(track.children).forEach(function (n) { var c = n.cloneNode(true); c.setAttribute('aria-hidden', 'true'); track.appendChild(c); });
    // 3) constant, calm speed (~32px/sec) regardless of how many clones were needed
    track.style.animationDuration = Math.max(40, Math.round(halfWidth / 32)) + 's';
  });

  /* ---------- mobile nav: close drawer on link tap ---------- */
  document.querySelectorAll('.nav__toggle').forEach(function (t) {
    var root = t.closest('.nav__inner') || document;
    root.querySelectorAll('.nav__group a, .nav__menu a').forEach(function (a) {
      a.addEventListener('click', function () { t.checked = false; });
    });
  });

  /* ---------- email-capture occasion toggle ---------- */
  document.querySelectorAll('.capture__options').forEach(function (group) {
    var opts = group.querySelectorAll('.opt');
    opts.forEach(function (b) {
      b.addEventListener('click', function (e) {
        e.preventDefault();
        opts.forEach(function (o) { o.classList.remove('is-active'); });
        b.classList.add('is-active');
        var scope = group.closest('.capture__inner') || document;
        var hidden = scope.querySelector('#qeOccasion');
        if (hidden) hidden.value = b.getAttribute('data-occasion') || '';
      });
    });
  });

  /* ---------- floating 10%-off offer: reveal after the hero scrolls past ---------- */
  var floatOffer = document.getElementById('qeFloatOffer');
  if (floatOffer) {
    var onFloat = function () {
      var y = window.scrollY || document.documentElement.scrollTop;
      floatOffer.classList.toggle('is-visible', y > 700);
    };
    window.addEventListener('scroll', onFloat, { passive: true });
    onFloat();
  }

  /* ---------- mystery-discount popup: once per visitor (localStorage), short delay ---------- */
  var mystery = document.getElementById('qeMystery');
  if (mystery && !DESIGN_MODE) {
    var closeMystery = function () { mystery.hidden = true; };
    var openMystery = function () { mystery.hidden = false; };
    try {
      if (!localStorage.getItem('qe_mystery_seen')) {
        setTimeout(function () { openMystery(); try { localStorage.setItem('qe_mystery_seen', '1'); } catch (e) {} }, 6000);
      }
    } catch (e) {}
    mystery.querySelectorAll('[data-mystery-close]').forEach(function (b) { b.addEventListener('click', closeMystery); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeMystery(); });
    var mf = mystery.querySelector('#qeMysteryForm');
    if (mf) mf.addEventListener('submit', function (e) {
      e.preventDefault();
      var r = mystery.querySelector('#qeMysteryReveal');
      if (r) { r.hidden = false; mf.hidden = true; }
      // TODO: wire email -> Klaviyo + real unique discount code (currently reveals the placeholder)
    });
  }

  /* ============================================================
     REAL SHOPIFY CART — Section Rendering API
     ============================================================ */
  var CART_SECTION = 'qe-cart-drawer';

  function openCart() {
    try {
      if (window.Rebuy && window.Rebuy.SmartCart && typeof window.Rebuy.SmartCart.show === 'function') {
        window.Rebuy.SmartCart.show();
        return;
      }
    } catch (e) {}
    document.documentElement.classList.add('qe-cart-open');
  }
  function closeCart() { document.documentElement.classList.remove('qe-cart-open'); }

  function qeAddToCart(vid) {
    fetch('/cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: [{ id: parseInt(vid, 10), quantity: 1 }], sections: CART_SECTION })
    }).then(function (r) { return r.json(); }).then(function (data) {
      if (data && data.sections) swapCart(data.sections[CART_SECTION]); else refreshCart();
      openCart();
    });
  }
  // Bind add-to-cart directly on each card button (target phase) so it fires before
  // third-party cart scripts (e.g. Rebuy) that hijack add-to-cart via document click
  // delegation and redirect to /cart. Mirrors the product page's direct binding.
  function qeFormAdd(form) {
    var btn = form.querySelector('[type="submit"]');
    if (btn) { btn.classList.add('is-loading'); btn.disabled = true; }
    var fd = new FormData(form);
    fd.append('sections', CART_SECTION);
    fetch('/cart/add.js', { method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest' }, body: fd })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data && data.status && data.status >= 400) {
          if (btn) { btn.classList.remove('is-loading'); btn.disabled = false; }
          alert(data.description || 'Sorry, that item could not be added.');
          return;
        }
        if (data && data.sections && data.sections[CART_SECTION]) swapCart(data.sections[CART_SECTION]); else refreshCart();
        openCart();
        if (btn) { btn.classList.remove('is-loading'); btn.disabled = false; }
      })
      .catch(function () { if (btn) { btn.classList.remove('is-loading'); btn.disabled = false; } window.location = '/cart'; });
  }
  function qeBindDirectAdd() {
    document.querySelectorAll('[data-qe-add]').forEach(function (btn) {
      if (btn.__qeAddBound) return;
      btn.__qeAddBound = true;
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        qeAddToCart(btn.getAttribute('data-qe-add'));
      });
    });
    document.querySelectorAll('form[action*="/cart/add"]').forEach(function (form) {
      if (form.__qeAddBound) return;
      form.__qeAddBound = true;
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        qeFormAdd(form);
      });
    });
  }
  if (document.readyState !== 'loading') qeBindDirectAdd();
  else document.addEventListener('DOMContentLoaded', qeBindDirectAdd);
  document.addEventListener('shopify:section:load', qeBindDirectAdd);

  // Locate the cart-drawer's section wrapper dynamically. When the drawer is
  // included via a section group its id is hashed (e.g.
  // shopify-section-sections--123__qe_cart_drawer), so we can't hardcode it.
  function cartWrapper() {
    var aside = document.querySelector('[data-qe-cart]');
    var n = aside;
    while (n && n !== document.body) {
      if (n.id && n.id.indexOf('shopify-section') === 0) return n;
      n = n.parentElement;
    }
    return document.getElementById('shopify-section-' + CART_SECTION); // fallback
  }
  function swapCart(html) {
    if (html == null) return;
    var wrap = cartWrapper();
    if (!wrap) return;
    // The Section Rendering API may return the section already wrapped in its
    // own .shopify-section element — unwrap it so we don't double-nest.
    var parsed = new DOMParser().parseFromString(html, 'text/html');
    var inner = parsed.querySelector('.shopify-section');
    wrap.innerHTML = inner ? inner.innerHTML : html;
    syncCount();
  }
  function syncCount() {
    var el = document.querySelector('[data-qe-cart-count]');
    var n = el ? parseInt(el.getAttribute('data-qe-cart-count'), 10) : null;
    if (n == null || isNaN(n)) return;
    document.querySelectorAll('[data-qe-nav-count]').forEach(function (c) { c.textContent = '(' + n + ')'; });
    document.querySelectorAll('.nav__cart').forEach(function (c) { c.classList.toggle('is-bumped', true); setTimeout(function(){ c.classList.remove('is-bumped'); }, 500); });
  }
  function refreshCart() {
    fetch('/?sections=' + CART_SECTION).then(function (r) { return r.json(); })
      .then(function (d) { swapCart(d[CART_SECTION]); });
  }

  // intercept every add-to-cart form (product cards + PDP)
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[action*="/cart/add"]');
    if (!form) return;
    e.preventDefault();
    qeFormAdd(form);
  });

  // delegated clicks: open / close / qty / remove / checkout / upsell add
  document.addEventListener('click', function (e) {
    var openBtn = e.target.closest('.nav__cart, [data-qe-cart-open]');
    if (openBtn) { e.preventDefault(); openCart(); return; }

    var closeBtn = e.target.closest('[data-qe-cart-close]');
    if (closeBtn) { e.preventDefault(); closeCart(); return; }

    var checkoutBtn = e.target.closest('[data-qe-checkout]');
    if (checkoutBtn) { e.preventDefault(); window.location = '/checkout'; return; }

    var addLine = e.target.closest('[data-qe-add]');
    if (addLine) {
      e.preventDefault();
      qeAddToCart(addLine.getAttribute('data-qe-add'));
      return;
    }

    var chip = e.target.closest('.rev__chips .chip, .filterbar__chips .chip');
    if (chip) {
      e.preventDefault();
      chip.parentNode.querySelectorAll('.chip').forEach(function (x) { x.classList.remove('is-active'); });
      chip.classList.add('is-active');
      return;
    }

    var qtyBtn = e.target.closest('[data-qe-line]');
    if (qtyBtn) {
      e.preventDefault();
      var line = qtyBtn.getAttribute('data-qe-line');
      var to = qtyBtn.getAttribute('data-qe-qty');
      fetch('/cart/change.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ line: parseInt(line, 10), quantity: parseInt(to, 10), sections: CART_SECTION })
      }).then(function (r) { return r.json(); }).then(function (data) {
        if (data && data.sections) swapCart(data.sections[CART_SECTION]); else refreshCart();
      });
      return;
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeCart();
  });

  // keep nav count correct on first load
  syncCount();

  /* ============================================================
     PDP buy box — gallery, pack select, qty, add-to-bag (real cart)
     ============================================================ */
  (function () {
    var pdp = document.querySelector('[data-qe-pdp]');
    if (!pdp) return;

    // gallery thumbnail switch
    var mainImg = pdp.querySelector('[data-qe-gallery-main]');
    pdp.querySelectorAll('.gallery__thumb').forEach(function (t) {
      t.addEventListener('click', function () {
        pdp.querySelectorAll('.gallery__thumb').forEach(function (x) { x.classList.remove('is-active'); });
        t.classList.add('is-active');
        var src = t.getAttribute('data-src');
        if (mainImg && src) mainImg.src = src;
      });
    });

    // qty stepper
    var qty = 1;
    var qtyVal = pdp.querySelector('[data-qe-qtyval]');
    function activePack() { return pdp.querySelector('.pack.is-active'); }
    function packQty() { var p = activePack(); return p ? parseInt(p.getAttribute('data-qty') || '1', 10) : 1; }
    function packPrice() { var p = activePack(); return p ? parseFloat(p.getAttribute('data-price') || '0') : 0; }
    function fmt(n) { return '$' + n.toFixed(2); }
    function syncBag() {
      var el = pdp.querySelector('[data-qe-bagprice]');
      if (el) el.textContent = fmt(packPrice() * qty);
    }
    pdp.querySelectorAll('.buy-row .qty__btn').forEach(function (b) {
      b.addEventListener('click', function () {
        qty = Math.max(1, qty + parseInt(b.getAttribute('data-step'), 10));
        if (qtyVal) qtyVal.textContent = qty;
        syncBag();
      });
    });
    pdp.querySelectorAll('.pack').forEach(function (p) {
      p.addEventListener('click', function () {
        pdp.querySelectorAll('.pack').forEach(function (x) { x.classList.remove('is-active'); });
        p.classList.add('is-active');
        syncBag();
      });
    });
    syncBag();

    function addSelected(then) {
      var p = activePack(); if (!p) return;
      var id = parseInt(p.getAttribute('data-variant'), 10);
      var q = packQty() * qty;
      fetch('/cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ items: [{ id: id, quantity: q }], sections: 'qe-cart-drawer' })
      }).then(function (r) { return r.json(); }).then(function (data) {
        var sec = document.getElementById('shopify-section-qe-cart-drawer');
        if (data && data.sections && data.sections['qe-cart-drawer'] && sec) { sec.innerHTML = data.sections['qe-cart-drawer']; }
        if (then === 'checkout') { window.location = '/checkout'; return; }
        openCart();
        var cEl = document.querySelector('[data-qe-cart-count]');
        if (cEl) document.querySelectorAll('[data-qe-nav-count]').forEach(function (c) { c.textContent = '(' + cEl.getAttribute('data-qe-cart-count') + ')'; });
      });
    }
    var addBtn = pdp.querySelector('[data-qe-pdp-add]');
    if (addBtn) addBtn.addEventListener('click', function (e) { e.preventDefault(); addSelected(); });
    var expressBtn = pdp.querySelector('[data-qe-pdp-checkout]');
    if (expressBtn) expressBtn.addEventListener('click', function (e) { e.preventDefault(); addSelected('checkout'); });

    // review filter chips (visual only)
    pdp.querySelectorAll('.rev__chips .chip, [data-qe-rev-chips] .chip').forEach(function (c) {
      c.addEventListener('click', function () {
        var sib = c.parentNode.querySelectorAll('.chip');
        sib.forEach(function (x) { x.classList.remove('is-active'); });
        c.classList.add('is-active');
      });
    });
  })();
})();
